import React, { useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import {Link} from 'react-router-dom'
const Image= () => {
  const [image, setImage] = useState(null);
  const [input, setInput] = useState("");

  const fetchImage = async () => {
    const response = await fetch(
      `https://api.unsplash.com/photos/random?query=${input}&client_id=Y5N9dyOGIt0UdA7bD984g4Ug_SWc-I3ivpuikMG3MfI`
    );
    const data = await response.json();
    setImage(data.urls.regular);
  };

  const handleClick = () => {
    if (input) {
      fetchImage();
    }
  };

  return (
    
       
    <div className="container my-5 ">
    <nav aria-label="breadcrumb" className='mt-2'>
    <ol className="breadcrumb text-dark ">
      <li className="breadcrumb-item "><Link to="/">Home</Link></li>
      <li className="breadcrumb-item active" aria-current="page">DDAI Image Generator</li>
    </ol>
  </nav>
      <h2 className="text-center">DDAI Image Generator</h2>
      <div className="form-group">
        <input
          type="text"
          className="form-control"
          placeholder="Enter a keyword"
          value={input}
          onChange={(e) => setInput(e.target.value)}
        />
      </div>
      <button className="btn btn-warning" onClick={handleClick}>Generate Image</button>
      <a
              href={image}
              download
              className="btn btn-primary m-3 "
            >
              Download the Image

            </a>
      {image && (
        <div className="my-3">
          <img src={image} className="card-img-top w-50 h-25 img-fluid" alt={input} />
          <div className="card-body ">
            <h5 className="card-title">Generated Image</h5>
           
          
          </div>
          
        </div>
        
      )}
    </div>
    
  );
};

export default Image;
